import { createAction, createReducer, createSelector } from 'redux-starter-kit'

export const UPDATE_NOTE = '[notes] update note'
export const LOAD_NOTES = '[notes] load notes'

export const updateNoteAction = createAction(UPDATE_NOTE)
export const loadNotesAction = createAction(LOAD_NOTES)

const itemsSelector = (state) => state.test.items

export const notesSelector = (state) => state.assessmentNotes

export const notesByIndexSelector = createSelector(
  [itemsSelector, notesSelector],
  (items, notes) => {
    const notesInOrder = items.map((item) => !!notes[item._id]) // Returns true if the note exists for the given itemId
    return notesInOrder // Returns the notes in order
  }
)

export const getNoteContentSelector = createSelector(
  [notesSelector],
  (notes) => (itemId) => notes[itemId] || '' // Returns the note for the given itemId, or empty string if not found
)

// initial state
const intialState = {}

export default createReducer(intialState, {
  [UPDATE_NOTE]: (state, { payload }) => {
    // Updates the note for the given itemId
    const { itemId, content } = payload
    if (content === null || content === undefined) {
      // Remove the note from the store if content is null/undefined
      delete state[itemId]
    } else {
      state[itemId] = content
    }
  },
  [LOAD_NOTES]: (state, { payload }) => payload, // Simply replaces the state with the payload
})
